import { ethers } from 'ethers';

export default function publicKeyToAddress(publicKey: string) {
  // Remove the '04' prefix if present
  const publicKeyNoPrefix =
    publicKey.slice(0, 2) === '04' ? publicKey.slice(2) : publicKey;

  // Get the address by taking the Keccak-256 hash and extracting the last 20 bytes
  const address = ethers.utils.keccak256('0x' + publicKeyNoPrefix).slice(-40);

  // Convert to a checksum address
  const checksumAddress = ethers.utils.getAddress('0x' + address);

  return checksumAddress;
}
